import { Button } from '@chakra-ui/react';
import { PortalContext } from 'PortalContext';
import { Container } from 'components/Container';
import { ContainerHead } from 'components/ContainerHead';
import { DataTable } from 'components/DataTable/DataTable';
import { facilitiesTable } from 'components/DataTable/DataTableModels';
import { useApi } from 'lib/useApi';
import { Facility } from 'models/ApiModels';
import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { routes } from '../../routes';

export function PlacePage(): JSX.Element {
  const { id } = useParams<{ id: string }>();
  const { data: facilitiesResp, state: respState } = useApi<Facility[]>(
    `/facilities/place/${id}`,
  );
  const { data: placeResp } = useApi<any>(`/places/${id}`);
  const { dispatch } = React.useContext(PortalContext);

  React.useEffect(() => {
    dispatch({ type: 'SET_PAGE_STATE', payload: respState });
  }, [dispatch, respState]);

  if (respState !== 'success') return <></>;
  if (respState === 'success' && !respState?.length)
    return <p>Ingen data {respState}</p>;

  return (
    <>
      {placeResp && <ContainerHead children="" title={`${placeResp.name}`} />}
      <Container>
        <Link to={routes.editPlace.path.replace(':id', id)}>
          <Button variant="primary" mb={10}>
            {routes.editPlace.linkText}
          </Button>
        </Link>
        <DataTable
          title="Anläggningar"
          tableDef={facilitiesTable}
          data={facilitiesResp}
          showSearch={false}
          searchableFields={[]}
        />
      </Container>
    </>
  );
}
